import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


const Icon = ({id, type, animated, children, className, ...rest}) => {
    const iconType = `icon--${type}`;

    return (
        <i
            id={id}
            className={classNames('icon', iconType, {'icon-animated': animated}, className)}
            {...rest}
        >
            {children}
        </i>
    );
};

Icon.propTypes = {
    type: PropTypes.string.isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    animated: PropTypes.bool,
};

Icon.defaultProps = {
    animated: false,
    children: null,
    id: null,
    className: '',
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js